import { get } from 'utils/axios';
import { GetCustomQuestionsPublicEndpoint } from '@kouto/types';
import z from 'zod';

export type GetCustomQuestionsResponse = z.infer<
  typeof GetCustomQuestionsPublicEndpoint.responseSchema
>;

const getCustomQuestions = async (url: string) => {
  const response = await get<GetCustomQuestionsResponse>(url);
  return response.items;
};

export default getCustomQuestions;
